import FormValidationAlert from '@op/luna.yaweb-common-js/FormValidationAlert';
import { useContext, useEffect, useRef } from 'react';
import { Message } from '@messageformat/react';
import Api from '../../api';
import { InsuranceOfferContext } from '../../context';
import DirectLink from './DirectLink';
import './InsuranceOffer.scss';
import InsuranceSelector from './InsuranceSelector';
import KeepAlive from '../common/KeepAlive/KeepAlive';

const InsuranceOffer = (props) => {
  const initializer = useRef(false);
  const [state, setState] = useContext(InsuranceOfferContext);
  const { directLink } = DirectLink();

  const contactDetails = state.contactInfo;
  const {loggedInUser} = contactDetails || {loggedInUser: null}

  useEffect(() => {
    if (initializer.current) return;
    initializer.current = true;

    const getUserContext = async () => {
      try {
        const response = await Api.userContext();
        if (response?.status === 'OK') {
          const contactInfo = { ...response.data };
          contactInfo.firstName = contactInfo.firstName.trim();
          const action = { type: 'IO_CHANGE_CONTACTINFO', contactInfo };
          setState({ state, ...action }, action);
        } else {
          const action = { type: 'IO_CHANGE_SHOWEXCEPTIONMESSAGE' };
          setState({ state, ...action }, action);
          document
            .getElementById('alert')
            .scrollIntoView({ behavior: 'smooth' });
        }
      } catch (error) {
        const action = { type: 'IO_CHANGE_SHOWEXCEPTIONMESSAGE' };
        setState({ state, ...action }, action);
        document.getElementById('alert').scrollIntoView({ behavior: 'smooth' });
      }
    };

    directLink();
    if (process.env.NODE_ENV !== 'development') getUserContext();
  }, [directLink, setState, state]);

  return (
    <div id="InsuranceOffer">
      {loggedInUser === false && <KeepAlive />}
      <FormValidationAlert
        alertMessage={<Message id="errorText.formContains" />}
        scrollOffset={110}
      >
        <InsuranceSelector {...props} />
      </FormValidationAlert>
    </div>
  );
};
export default InsuranceOffer;
